var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('v-overlay',{attrs:{"absolute":"","opacity":0.3,"color":"rgba(0, 0, 0, 0.3)"}},[_c('v-img',{attrs:{"width":97,"height":97,"src":"/img/loader.svg"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }